import {
  ChangeDetectorRef,
  inject,
  OnDestroy,
  Pipe,
  PipeTransform
} from '@angular/core'
import { LanguageService } from '../services/language.service'
import { Subscription } from 'rxjs'

@Pipe({
  name: 'myDate',
  pure: false
})
export class MyDatePipe implements PipeTransform, OnDestroy {
  private langService = inject(LanguageService)
  private cdr = inject(ChangeDetectorRef)
  private onLangChange: Subscription | undefined
  private value = ''
  private lastValue?: Date | string
  private lastJustWeekday?: boolean
  private lastFormat?: string

  updateValue(value: Date | string, justWeekday?: boolean, format?: string) {
    if (justWeekday) {
      this.value = this.langService.weekdayTransform(value) ?? ''
    } else {
      this.value = this.langService.dateTransform(value, format) ?? ''
    }
  }

  transform(
    value: Date | string,
    justWeekday?: boolean,
    format?: string
  ): string {
    if (
      this.lastValue?.toString() === value?.toString() &&
      this.lastJustWeekday === justWeekday &&
      this.lastFormat === format
    ) {
      return this.value
    }

    this.lastValue = value
    this.lastJustWeekday = justWeekday
    this.lastFormat = format

    this.updateValue(value, justWeekday, format)

    this.onLangChange?.unsubscribe()
    this.onLangChange = undefined
    this.onLangChange = this.langService.langSource.subscribe(() => {
      this.lastValue = undefined
      this.updateValue(value, justWeekday, format)
      this.cdr.markForCheck()
    })

    return this.value
  }

  ngOnDestroy(): void {
    this.onLangChange?.unsubscribe()
  }
}
